import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from '@/contexts/AuthContext';
import { ThemeProvider } from '@/contexts/ThemeContext';
import { ToastProvider } from '@/contexts/ToastContext';
import { NotificationProvider } from '@/contexts/NotificationContext';
import { MessageProvider } from '@/contexts/MessageContext';
import { PushNotificationProvider } from '@/contexts/PushNotificationContext';
import { CallProvider } from '@/contexts/CallContext';
import { useAuth } from '@/contexts/AuthContext';
import Layout from '@/components/layout/Layout';
import HomeFeed from '@/pages/HomeFeed';
import LoginPage from '@/pages/auth/LoginPage';
import SignupPage from '@/pages/auth/SignupPage';
import ForgotPasswordPage from '@/pages/auth/ForgotPasswordPage';
import ResetPasswordPage from '@/pages/auth/ResetPasswordPage';
import OnboardingPage from '@/pages/OnboardingPage';
import ProfilePage from '@/pages/ProfilePage';
import SettingsPage from '@/pages/SettingsPage';
import SearchPage from '@/pages/SearchPage';
import NotificationsPage from '@/pages/NotificationsPage';
import MessagesPage from '@/pages/MessagesPage';
import PostPage from '@/pages/PostPage';
import BookmarksPage from '@/pages/BookmarksPage';
import { ModalProvider } from '@/components/ui/Modal';
import { Skeleton } from '@/components/ui/Skeleton';

function ProtectedRoute({ children }: { children: any }) {
  const { user, loading } = useAuth();
  if (loading) return <Skeleton className="h-screen" />;
  return user ? children : <Navigate to="/login" replace />;
}

function AppLayout({ children }: { children: any }) {
  return (
    <ProtectedRoute>
      <Layout>{children}</Layout>
    </ProtectedRoute>
  );
}

function GuestRoute({ children }: { children: any }) {
  const { user, loading } = useAuth();
  if (loading) return <Skeleton className="h-screen" />;
  return user ? <Navigate to="/" replace /> : children;
}

function App() {
  return (
    <AuthProvider>
      <ThemeProvider>
        <ToastProvider>
          <ModalProvider>
            <NotificationProvider>
            <MessageProvider>
              <PushNotificationProvider>
                <CallProvider>
                  <BrowserRouter>
                    <Routes>
                      <Route path="/login" element={<GuestRoute><LoginPage /></GuestRoute>} />
                      <Route path="/signup" element={<GuestRoute><SignupPage /></GuestRoute>} />
                      <Route path="/forgot-password" element={<GuestRoute><ForgotPasswordPage /></GuestRoute>} />
                      <Route path="/reset-password" element={<ResetPasswordPage />} />
                      <Route path="/onboarding" element={<ProtectedRoute><OnboardingPage /></ProtectedRoute>} />
                      <Route path="/" element={<AppLayout><HomeFeed /></AppLayout>} />
                      <Route path="/:username" element={<AppLayout><ProfilePage /></AppLayout>} />
                      <Route path="/settings" element={<AppLayout><SettingsPage /></AppLayout>} />
                      <Route path="/search" element={<AppLayout><SearchPage /></AppLayout>} />
                      <Route path="/bookmarks" element={<AppLayout><BookmarksPage /></AppLayout>} />
                      <Route path="/notifications" element={<AppLayout><NotificationsPage /></AppLayout>} />
                      <Route path="/messages" element={<AppLayout><MessagesPage /></AppLayout>} />
                      <Route path="/post/:id" element={<AppLayout><PostPage /></AppLayout>} />
                      <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                  </BrowserRouter>
                </CallProvider>
              </PushNotificationProvider>
            </MessageProvider>
          </NotificationProvider>
        </ModalProvider>
      </ToastProvider>
      </ThemeProvider>
    </AuthProvider>
  );
}

export default App;
